import { useState, useEffect, useRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query';

import authAxios from "../../components/authAxios";

import { Autocomplete } from "@mui/material";
import { TextField } from "@mui/material";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';

//ANT DESIGN
import { message, Upload } from 'antd';
import { DeleteOutlined, LoadingOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons';
import { Steps, Button, Radio } from 'antd';

import NumberFormat from "react-number-format";

import moment from 'moment';

import { UserContext } from "../../App";

import UserAlerts from "../../components/UserAlerts";

import CustomerRelatedParties from "./CustomerRelatedParties";
import '../loans/Loans.css'
import DashboardHeader from "../../components/DashboardHeader";

const CustomerNew =()=> {    
    const navigate = useNavigate();

    const { maxFileSizeMB } = useContext(UserContext);
    const [error, setError] = useState('');
    const errorRef = useRef(null);
    const queryClient = useQueryClient();

    const [isModalOpen, setIsModalOpen] = useState(false);

    const { data: countries } = useQuery({
        queryKey: ['countries'],
        queryFn: async () => {
          const response = await authAxios.get('/countries');
          return response.data
        },
    });

    const maritalStatusList = [
        {
            id: 'SINGLE',
            label: 'Single',
        },
        {
            id: 'MARRIED',
            label: 'Married',
        },
        {
            id: 'DIVORCED',
            label: 'Divorced',
        },
        {
            id: 'WIDOWED',
            label: 'Widowed',
        },
    ];

    const legalStructures = [
        {
            id: 'SOLE_PROPRIETORSHIP',
            label: 'Sole Proprietorship',
        },
        {
            id: 'PARTNERSHIP',
            label: 'Partnership',
        },
        {
            id: 'LLC',
            label: 'Limited Liability Company',
        },
        {
            id: 'CORPORATION',
            label: 'Corporation',
        },
    ];

    const user = localStorage.getItem('userID');
    const client = localStorage.getItem('clientID');

    const [birthDate, setBirthDate] = useState(null);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [mobile, setMobile] = useState('');
    const [nationality, setNationality] = useState('');
    const [website, setWebsite] = useState('');
    const [id_type, setId_type] = useState('');
    const [id_number, setId_number] = useState('');
    const [registrationNumber, setRegistrationNumber] = useState('');
    const [registrationDate, setRegistrationDate] = useState(null);
    const [relatedParties, setRelatedParties] = useState([]);

    const addressKey = useRef(0);
    const emptyAddress = () => ({
        key: addressKey.current++, address_type: 'RESIDENTIAL', address_line_1: '', address_line_2: '', city: '', country: '',
    });
    const [addresses, setAddresses] = useState([emptyAddress()]);

    const updateAddress = (key, field, value) =>
        setAddresses(prev => prev.map(a => (a.key === key ? { ...a, [field]: value } : a)));
    const addAddress = () => setAddresses(prev => [...prev, emptyAddress()]);
    const removeAddress = (key) => setAddresses(prev => prev.filter(a => a.key !== key));

    const [contactDocs, setContactDocs] = useState([]);
    const [photo, setPhoto] = useState([]);

    const [gender, setGender] = useState('');
    const [contactType, setContactType] = useState(10);
    const [maritalStatus, setMaritalStatus] = useState('');
    const [legalStructure, setLegalStructure] = useState('');
    const [memo, setMemo] = useState('');

    const [idNumberError, setIdNumberError] = useState(false)
 
    const [idStepTitle, setIdStepTitle] = useState('');

    const [tableData, setTableData] = useState([]);

    const addRelatedParty = (newRelatedParty) => {
        // setTableData([...tableData, newRelatedParty]);
        setRelatedParties((prev) => [...prev, newRelatedParty]);
        setIsModalOpen(false); 
    };


    const isStepValid = () => {
        if (currentStep === 0) {
        return name.trim() !== '' && mobile.trim() !== '';
        }
      
        if (currentStep === 1) {
        return addresses.length > 0 &&
            addresses.every(a => a.address_type && a.address_line_1.trim() !== '');
        }
      
        if (currentStep === 2) {
        //   return !!owner;
        return true
        }

        if (currentStep === 3) {
        return true;
        }

        if (currentStep === 4) {
            return true;
        }      
        return false;
    };


    const { Step } = Steps;
    const [currentStep, setCurrentStep] = useState(0);

    const nextStep = () => {
      setCurrentStep(currentStep + 1);
    };
  
    const prevStep = () => {
      setCurrentStep(currentStep - 1);
    };


    const handleIdNumber = (e) => {
        if (e.target.value.length>9){
            setIdNumberError(true)
        }
        else{
            setIdNumberError(false)
            setId_number(e.target.value)
        }
    }

    // IMAGE UPLOAD ANT DESIGN
    // const [fileUrl, setFileUrl] = useState();
    const [imageUrl, setImageUrl] = useState();
    const [loading, setLoading] = useState(false);
    // const [isProcessing, setIsProcessing] = useState(false);  // New state for form submission


    // const getBase64 = (img, callback) => {
    //     const reader = new FileReader();
    //     reader.addEventListener('load', () => callback(reader.result));
    //     reader.readAsDataURL(img);
    // };


    const beforeUpload = (file) => {
        const isTooLarge = file.size / 1024 / 1024 > maxFileSizeMB;
        if (isTooLarge) {
            message.error(`File too large. Maximum size is ${maxFileSizeMB}MB.`);
            return Upload.LIST_IGNORE; // prevents adding to UI list
        }
        return false; // continue with manual upload handling
        };
    

    const handleFileUpload = (info, type, document_number, issue_date, expiry_date) => {
        const fileList = info.fileList.map(f => {
            return {
            uid: f.uid,
            name: f.name,
            file: f.originFileObj || f,
            document_type: type,
            document_number: document_number || '',
            issue_date: issue_date || null,
            expiry_date: expiry_date || null,
            };
        });

        if (type === 'PROFILE_PHOTO') {
            console.log("FILE LIST PHOTOS", fileList)
            setPhoto(fileList[0]); // only one photo
        } else {
            setContactDocs(fileList);
        }
    };
    
    const uploadButton = (
        <div>
            {loading ? <LoadingOutlined /> : <PlusOutlined />}
            <div 
            style={{
                marginTop: 8,
            }}
            >
            Upload
            </div>
        </div>
    );

    const mutation = useMutation({
        mutationFn: (contact) => {
            return authAxios.post('/contacts/', contact, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
            });
        },
        onError: (error, variables, context) => {
            console.log("ERROR",error)
            if (error.response.data){
                const errorData = error.response.data;
                Object.keys(errorData).map((field, index) => (
                        <div key={index}> {/* Wrap content in a container (optional) */}
                            {
                            Array.isArray(errorData[field]) ? (
                                
                            <ul> {/* Use a list for arrays */}
                                {errorData[field].map((errorMessage) => (
                                <li key={index}> {/* Use the index as the key */}
                                    {setError(`${field}: ${errorMessage}`)}
                                </li>
                                ))}
                            </ul>
                            ) : (
                            <p>{setError(`${errorData[field]}`)}</p>
                            )}
                        </div>
                    ));
         
            } 
            else {
                setError(error.message); 
            }      
        },
        onSuccess: (result) => {
            queryClient.invalidateQueries(['customers']);
            navigate('/dashboard/customers/');
            // setIsModalOpen(false)
        },
      })


    const handleSubmit = (e) => {
        e.preventDefault();
        setError('')

        if (!name) {    
            setError("Name is required")
            return
        }

        if (!mobile) {    
            setError("Mobile number is required")
            return
        }

        const telephone = mobile.replace(/[()" "]/g,"")
        
        // Build FormData for multipart upload
        const formData = new FormData();
        formData.append('type', contactType);
        formData.append('contact_type', contactType);
        formData.append('client', client);
        formData.append('name', name);
        formData.append('legal_structure', legalStructure);
        // TODO: legacy single-address fields, dual-written from the first address.
        // Delete these two appends once CustomerView.js and CustomerEdit.js read the
        // `addresses` list instead of the flat customer.address / customer.city.
        formData.append('address', addresses[0]?.address_line_1 || '');
        formData.append('city', addresses[0]?.city || '');
        formData.append('country', nationality);
        formData.append('email', email);
        formData.append('website', website);
        formData.append('telephone', telephone);
        formData.append('gender', gender);
        formData.append('id_type', id_type);
        formData.append('id_number', id_number);
        formData.append('registration_number', registrationNumber);
        formData.append('registration_date', registrationDate || '');
        formData.append('birth_date', birthDate || '');
        formData.append('marital_status', maritalStatus);
        formData.append('user', user);
        formData.append('memo', memo);
        formData.append('category', 'CUSTOMER');

        formData.append('related_parties', JSON.stringify(
            relatedParties.map(({ contactId, relationship }) => ({
                contact: contactId,
                relationship,
            }))
        ));

        formData.append('addresses', JSON.stringify(
            addresses.map(({ address_type, address_line_1, address_line_2, city, country }) => ({
                address_type,
                address_line_1,
                address_line_2: address_line_2 || null,
                city: city || null,
                country: country || null,
            }))
        ));

        // Combine docs + photo
        const allDocs = [...contactDocs];
        if (Array.isArray(photo) && photo.length > 0) {
            allDocs.push(...photo);
        }

        formData.append('contact_docs_metadata', JSON.stringify(
            allDocs.map(({ document_type, document_number, issue_date, expiry_date }) => ({
            document_type,
            document_number,
            issue_date,
            expiry_date,
            }))
        ));

        allDocs.forEach(doc => formData.append('contact_docs_files', doc.file));
        console.log("FORMDATA", formData)
        mutation.mutate(formData);
    }

    useEffect(()=>{
        if (error){
            errorRef.current.scrollIntoView();  
        }            
    },[error])   

    useEffect(() => {
        if (contactType === 10) {
            setIdStepTitle('Identity');
        } else {
            setIdStepTitle('Documents');
        }
    }, [contactType]);


    // console.log("Table Data", tableData)


    return(
        <div className="dashboard-main">
            <section className="dashboard-content">
                <section className="dashboard-form dashboard-form-compact">
                    <div ref={errorRef}>
                        <UserAlerts error={error}  />
                    </div>
                    <DashboardHeader dashboardTitle="Add Customer" dashboardPreTitle="Loans" />

                    <Steps size="small" current={currentStep} >
                        <Step title="Profile" />
                        <Step title="Addresses"  />
                        <Step title="Next of Kin"  /> 
                        <Step title={idStepTitle}  />
                        {contactType === 10 &&
                            <Step title="Photo"  />
                        }
                    </Steps>

                    <form noValidate autoComplete="off" onSubmit={handleSubmit}>
                        {currentStep === 0 && (
                        <>
                            <Radio.Group 
                                size="large" 
                                value={contactType}
                                onChange={(e) => setContactType(e.target.value)}
                                className="custom-input"
                            >
                                <Radio.Button  value={10}>Individual</Radio.Button>
                                <Radio.Button value={20}>Company</Radio.Button>
                            </Radio.Group>

                            <TextField className="custom-input"
                                onChange={(e) => {setName(e.target.value)}}
                                label="Name" 
                                variant="outlined" 
                                fullWidth
                                required
                                // error={nameError}
                            />

                            <div className="two-columns">
                                <NumberFormat
                                    onChange={(e) => {setMobile(e.target.value)}}
                                    className="custom-input"
                                    fullWidth
                                    label="Telephone"
                                    variant="outlined"
                                    customInput={TextField}
                                    format="### (###) ######" mask="_"
                                    required
                                />

                                <TextField className="custom-input"
                                    onChange={(e) => {
                                        setEmail(e.target.value)
                                    }}
                                    label="Email"
                                    variant="outlined"
                                    fullWidth
                                />
                            </div>

                            {contactType===20 &&
                            <TextField className="custom-input"
                                onChange={(e) => setWebsite(e.target.value)}
                                label="Website"
                                variant="outlined"
                                fullWidth
                            />
                            }

                            {contactType===10 &&
                            <>
                                <div className="two-columns">
                                    <LocalizationProvider dateAdapter={AdapterMoment}>
                                        <DesktopDatePicker
                                            value={birthDate}
                                            label="Birth Date"
                                            inputFormat="DD-MM-YYYY"
                                            onChange={(newDate) => setBirthDate(moment(newDate).format("YYYY-MM-DD"))}
                                            renderInput={(params) => <TextField fullWidth required className="custom-input" {...params} />}
                                        />
                                    </LocalizationProvider>
                                    <Autocomplete
                                        onChange={(event, newValue) => setMaritalStatus(newValue.id)}
                                        options={maritalStatusList}
                                        getOptionLabel={(option) => option.label}
                                        renderInput={(params) => <TextField className="custom-input" fullWidth {...params} label="Marital Status"  /> }
                                    />
                                </div>
                                <Radio.Group
                                    onChange={(e) => setGender(e.target.value)}
                                    className="custom-input"
                                >
                                    <Radio  value="F">Female</Radio>
                                    <Radio value="M">Male</Radio>
                                </Radio.Group>
                            </>
                            }
                            {contactType===20 &&   
                            <> 
                                <Autocomplete
                                    onChange={(event, newValue) => setLegalStructure(newValue.id)}
                                    options={legalStructures}
                                    getOptionLabel={(option) => option.label}
                                    renderInput={(params) => <TextField className="custom-input" fullWidth {...params} label="Type of Business"  /> }
                                /> 
                            </>
                            }
                        </>
                        )}

                        {currentStep === 1 && (
                        <>
                            <div className="address-section-header">
                                <span className="address-section-title">ADDRESSES</span>
                                <span className="address-section-hint">At least one address is required</span>
                            </div>

                            <div className="address-card-grid">
                                {addresses.map((a) => (
                                    <div className="address-card" key={a.key}>
                                        <div className="address-card-header">
                                            <Radio.Group
                                                size="large"
                                                value={a.address_type}
                                                onChange={(e) => updateAddress(a.key, 'address_type', e.target.value)}
                                            >
                                                <Radio.Button value="RESIDENTIAL">Residential</Radio.Button>
                                                <Radio.Button value="BUSINESS">Business</Radio.Button>
                                            </Radio.Group>

                                            {addresses.length > 1 && (
                                                <Button
                                                    type="text"
                                                    className="address-card-delete"
                                                    icon={<DeleteOutlined />}
                                                    onClick={() => removeAddress(a.key)}
                                                    title="Delete address"
                                                    aria-label="Delete address"
                                                />
                                            )}
                                        </div>

                                        <TextField className="custom-input"
                                            value={a.address_line_1}
                                            onChange={(e) => updateAddress(a.key, 'address_line_1', e.target.value)}
                                            label="Street/building/landmark"
                                            variant="outlined"
                                            fullWidth
                                            required
                                        />

                                        <TextField className="custom-input"
                                            value={a.address_line_2}
                                            onChange={(e) => updateAddress(a.key, 'address_line_2', e.target.value)}
                                            label="Floor/unit (optional)"
                                            variant="outlined"
                                            fullWidth
                                        />

                                        <TextField className="custom-input"
                                            value={a.city}
                                            onChange={(e) => updateAddress(a.key, 'city', e.target.value)}
                                            label="City/Town"
                                            variant="outlined"
                                            fullWidth
                                        />

                                        <Autocomplete
                                            options={countries || []}
                                            getOptionLabel={(option) => option.name}
                                            onChange={(event, newValue) => updateAddress(a.key, 'country', newValue ? newValue.id : '')}
                                            renderInput={(params) => <TextField className="custom-input" fullWidth {...params} label="Country" /> }
                                        />
                                    </div>
                                ))}

                                <button type="button" className="address-add-tile" onClick={addAddress}>
                                    <PlusOutlined style={{ fontSize: 22 }} />
                                    ADD ADDRESS
                                </button>
                            </div>
                        </>
                        )}


                        {currentStep === 2 && (
                        <>
                            <CustomerRelatedParties 
                                addRelatedParty={addRelatedParty}
                                // tableData={tableData} 
                                tableData={relatedParties} 
                                // setTableData={setTableData} 
                                setRelatedParties={setRelatedParties}
                                isModalOpen={isModalOpen}
                                setIsModalOpen={setIsModalOpen}
                            />
                        </>
                        )}

                        
                        {currentStep === 3 && (
                        <> 
                            {contactType === 10 && 
                            <>
                            <Autocomplete
                                onChange={(event, newValue) => {setNationality(newValue ? newValue.id : '');}}
                                options={countries || []}
                                getOptionLabel={(option) => option.name}
                                renderInput={(params) => <TextField className="custom-input" fullWidth {...params} label="Nationality"  /> }
                            /> 

                            <Radio.Group
                                onChange={(e) => setId_type(e.target.value)}
                                className="custom-input"
                            >
                                <Radio value={"NATIONAL_ID"}>National ID</Radio>
                                <Radio value={"PASSPORT"}>Passport</Radio>
                            </Radio.Group>

                            <TextField className="custom-input"
                                onChange={handleIdNumber}
                                label="ID/Passport Number" 
                                helperText="Maximum number of characters is 9" 
                                variant="outlined" 
                                fullWidth
                                required
                                error={idNumberError}
                            /> 
                            <Upload
                                name="file"
                                beforeUpload={beforeUpload}
                                onChange={(info) => handleFileUpload(info, 'NATIONAL_ID', id_number)}
                                maxCount={2}
                            >
                                <Button
                                    style={{ marginTop: '1.5rem' }}
                                    icon={<UploadOutlined />}
                                >Click to Upload</Button>
                            </Upload>
                            </>}

                            {contactType === 20 &&  
                            <>
                                <TextField className="custom-input"
                                    onChange={(e) => setRegistrationNumber(e.target.value)}
                                    label="Registration Number" 
                                    variant="outlined" 
                                    fullWidth
                                />  
                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                    <DesktopDatePicker
                                        value={registrationDate}
                                        label="Registration Date"
                                        inputFormat="DD-MM-YYYY" 
                                        onChange={(newDate) => {
                                            setRegistrationDate(moment(newDate).format("YYYY-MM-DD"));
                                        }}
                                        renderInput={(params) => <TextField fullWidth required className="custom-input" {...params} />}
                                    />
                                </LocalizationProvider>

                                <Upload
                                    name="file"
                                    beforeUpload={beforeUpload}
                                    onChange={(info) => handleFileUpload(info, 'REGISTRATION_CERTIFICATE', registrationNumber)}
                                    maxCount={2}
                                >
                                    <Button
                                        style={{ marginTop: '1.5rem' }}
                                        icon={<UploadOutlined />}
                                    >Click to Upload</Button>
                                </Upload>
                            </>
                            }   

                        </>
                        )}

                        {currentStep === 4 && (
                        <> 
                        <Upload
                            name="photo"
                            listType="picture-card"
                            className="avatar-uploader custom-upload-card custom-input"
                            beforeUpload={beforeUpload}
                            onChange={(info) => handleFileUpload(info, 'PROFILE_PHOTO')}
                            maxCount={1}
                            >
                            {imageUrl ? (
                                <img
                                src={imageUrl}
                                alt="avatar"
                                style={{
                                    width: '100%',
                                }}
                                />
                            ) : (
                                uploadButton
                            )}
                        </Upload>
                        </>
                        )}

                        <div className="button-border-top">
                            {currentStep > 0 && (
                                <Button type="default" onClick={prevStep}>
                                    Previous
                                </Button>
                            )}

                            {contactType===10 && 
                            <>
                                {currentStep < 4 && (
                                    <Button type="primary" onClick={nextStep} disabled={!isStepValid()}>
                                        Next
                                    </Button>
                                )}
                                {currentStep === 4 && (
                                    <Button 
                                        type="primary" 
                                        htmlType="submit" 
                                        disabled={!isStepValid()}
                                        loading={mutation.isLoading}
                                    >
                                        Save
                                    </Button>    
                                )}
                            </>}

                            {contactType===20 && 
                            <>
                                {currentStep < 3 && (
                                    <Button type="primary" onClick={nextStep} disabled={!isStepValid()}>
                                        Next
                                    </Button>
                                )}
                                {currentStep === 3 && (
                                    <Button 
                                        type="primary" 
                                        htmlType="submit" 
                                        disabled={!isStepValid()}
                                        loading={mutation.isLoading}
                                    >
                                        Save
                                    </Button>    
                                )}
                   
                            </>}
                    
                        </div>
                    </form>
                </section>
            </section> 
        </div>
    )
}

export default CustomerNew;




